import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bill-payments-form',
  templateUrl: './bill-payments-form.component.html',
  styleUrls: ['./bill-payments-form.component.css']
})
export class BillPaymentsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/billing/bill-payments/bill-payments-form/bill-payments-form.component.ts